import React from 'react';
import { Link } from 'gatsby';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';
import routes from '../../constants/routes';

const Header = () => {
    return (
        <Navbar className="Header" expand="lg" bg="primary" variant="dark" sticky="top">
            <Navbar.Brand className="d-block d-lg-none">
                Alouf Custom Builders
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="nav" />
            <Navbar.Collapse id="nav">
                <Nav className="ml-auto mr-auto">
                    <Link to={routes.home} className="navbar-dark navbar-nav nav-link" data-umami-event="nav-header" data-umami-event-target="home">Home</Link>
                    <Link to={routes.about} className="navbar-dark navbar-nav nav-link" data-umami-event="nav-header" data-umami-event-target="about">About Us</Link>
                    <NavDropdown title="Gallery" id="gallery-dropdown">
                        <Link to={routes.gallery_custom} className="dropdown-item" data-umami-event="nav-header" data-umami-event-target="gallery-custom">Custom Homes</Link>
                        <Link to={routes.gallery_remodels} className="dropdown-item" data-umami-event="nav-header" data-umami-event-target="gallery-remodels">Remodels</Link>
                        <Link to={routes.gallery_additions} className="dropdown-item" data-umami-event="nav-header" data-umami-event-target="gallery-additions">Additions</Link>
                        <Link to={routes.gallery_garages} className="dropdown-item" data-umami-event="nav-header" data-umami-event-target="gallery-garages">Garages</Link>
                    </NavDropdown>
                    <Link to={routes.testimonials} className="navbar-dark navbar-nav nav-link" data-umami-event="nav-header" data-umami-event-target="testimonials">Testimonials</Link>
                    <Link to={routes.vendors} className="navbar-dark navbar-nav nav-link" data-umami-event="nav-header" data-umami-event-target="vendors">Vendors</Link>
                    <NavDropdown title="Resources" id="resources-dropdown">
                        <Link to={routes.faq} className="dropdown-item" data-umami-event="nav-header" data-umami-event-target="faq">FAQ</Link>
                        <Link to={routes.building_101} className="dropdown-item" data-umami-event="nav-header" data-umami-event-target="building-101">Building 101</Link>
                        <Link to={routes.what_to_expect} className="dropdown-item" data-umami-event="nav-header" data-umami-event-target="what-to-expect">What to Expect</Link>
                        {/*<Link to={routes.our_process} className="dropdown-item">Our Process</Link>*/}
                    </NavDropdown>
                </Nav>
            </Navbar.Collapse>
        </Navbar>
    );
};

export default Header;
